import axios from "axios";

export function useAdminCalls() {
    const loadTags = async () => {
        const storeApiUrl = getOrigin() + "/api/cached/tags";
        const response = await axios.get(storeApiUrl);

        return response.data;
    }
    const loadCustomDeliveryDateConfig = async () => {
        const { sessionContext } = useSessionContext();
        let query = ''
        if (sessionContext.value?.salesChannel?.id) {
            query = '?salesChannelId=' + sessionContext.value?.salesChannel?.id;
        }
        const storeApiUrl = getOrigin() + "/api/cached/config/custom-delivery-date"+query;
        const response = await axios.get(storeApiUrl);

        return response.data;
    }
    const updateOrderInformation = async (orderData: any) => {
        const storeApiUrl = getOrigin() + "/api/admin/order/"+orderData.id;
        await axios.patch(storeApiUrl, orderData);
    }
    return {
        loadTags,
        loadCustomDeliveryDateConfig,
        updateOrderInformation
    }
}

function getOrigin(): string | undefined {
    let origin = "";
    const nuxtApp = useNuxtApp();
    const isDeV = process.env.NODE_ENV !== 'production';

    if (import.meta.server) {
        if (nuxtApp.ssrContext?.event.node.req.headers.host !== "undefined") {
            const location = isDeV ? "http://" : "https://"; // in dev mode we need to use http
            const host = nuxtApp.ssrContext?.event.node.req.headers.host;
            origin = location + host
        }
    } else {
        origin = window.location.origin;
    }

    return origin;
}